import { servicePost } from "./client.ts";

export interface GenerateCodesArgs {
  iPromotionID: number;
  sCodeTemplate: string;
  iCount: number;
  dCodeFromDate: string;
  dCodeToDate: string;
  sCampaignName: string;
}

export interface GenerateCodesResult {
  iGenerationGroup: number;
  iPromotionCodeId: number;
}

export interface PromotionCode {
  PromotionCodeID: number;
  PromotionID: number;
  Code: string;
  UsedCount: number;
  Status: string;
  CodeFromDate: string;
  CodeToDate: string;
  CalcTS: number;
}

export function emptyPromotionCode(): PromotionCode {
  return {
    PromotionCodeID: 0,
    PromotionID: 0,
    Code: "",
    UsedCount: 0,
    Status: "",
    CodeFromDate: new Date().toISOString(),
    CodeToDate: new Date().toISOString(),
    CalcTS: 0,
  };
}

export async function generatePromotionCodes(
  args: GenerateCodesArgs,
): Promise<GenerateCodesResult> {
  const result = await servicePost<number>("WebGeneratePromotionCodes", args as unknown as Record<string, unknown>);
  if (result.bError) throw new Error(result.sMessage || "Failed generating promotion codes");

  const value = result.oData ?? 0;
  if (args.iCount > 1) {
    return { iGenerationGroup: value, iPromotionCodeId: 0 };
  }
  return { iGenerationGroup: 0, iPromotionCodeId: value };
}

export async function getPromotionCode(codeId: number): Promise<PromotionCode> {
  const result = await servicePost<PromotionCode>("WebGetPromotionCode", { codeId });
  if (result.bError || !result.oData) throw new Error(result.sMessage || "Failed to load promotion code");
  return result.oData;
}

export async function savePromotionCode(code: PromotionCode): Promise<PromotionCode> {
  const result = await servicePost<PromotionCode>("WebSetPromotionCode", { code });
  if (result.bError || !result.oData) {
    const msg = result.eErrorType === 3 /* ItemOutOfDate */
      ? "Promotion code has been changed on the server. Please reload and try again."
      : (result.sMessage || "Failed to save promotion code");
    throw new Error(msg);
  }
  return result.oData;
}
